import React, { useEffect, useState } from "react";
import ModalBasic from "../ModalBasic";
import _ from "lodash";
import { GetDataOptions } from "../../utils/Utils";
import Select from "react-select";
import Banner from "../Banner/Banner";
import Button from "../Button/Button";

export default function ModalQR({
  showModal,
  setShowModal,
  modalQRDetails,
  inputQR,
  setInputQR,
  functionAdd,
  functionEdit,
  userData,
  dataOutletKartini,
}) {
  // initial variabel for validation
  const [isLoading, setIsLoading] = useState(false);
  const [validationQR, setValidationQR] = useState({
    email: {
      validate: true,
      message: "",
    },
    phone: {
      validate: true,
      message: "",
    },
    general: {
      validate: true,
      message: "",
    },
  });

  const FilterData = [
    {
      url: `project?retailer=${userData?.outlet?.retailer?.id ?? ""}&limit=99999&isActive=true`,
      label: "name",
      key: "id",
      name: "project",
    },
    {
      url: `chat/question-trigger?limit=99999&isActive=true&${inputQR?.project ? `&project=${inputQR?.project}` : ""}`,
      label: "questionTrigger",
      key: "id",
      name: "chatQuestionTrigger",
    },
    {
      url: `users?retailer=${userData?.outlet?.retailer?.id ?? ""}&applicationType=WALLET&limit=10000&isActive=true`,
      label: (user) => `${user.profile?.firstName} ${user.profile?.lastName}`,
      key: (user) => user.userOutlet?.[0]?.id,
      name: "userOutlet",
    },
  ];

  const [options, setOptions] = useState({});

  useEffect(() => {
    GetDataOptions(FilterData, setOptions, setIsLoading);
    return () => {
      setOptions({});
    };
  }, [inputQR.project]);

  return (
    <>
      {/* Modal ADD QR */}
      <ModalBasic
        name="add_outlet_modal"
        open={showModal}
        setOpen={setShowModal}
        title={modalQRDetails.title}
        enClose={true}
      >
        <div className="">
          <div className="space-y-3">
            {/* PROJECT */}
            <div className="text-sm font-semibold text-gray-600">Project</div>
            <Select
              className="col-span-full sm:col-span-2"
              placeholder="Project Name"
              options={options?.project?.data}
              // value={options?.project?.data.filter(
              //   (option) => option.value === inputQR.project,
              // )}
              value={
                inputQR.project
                  ? _.find(options.project?.data, {
                      value: inputQR.project,
                    })
                  : ""
              }
              onChange={(e) =>
                setInputQR((prevState) => ({
                  ...prevState,
                  project: e.value,
                }))
              }
            />
            {/* HASHTAG */}
            <div className="text-sm font-semibold text-gray-600">Hashtag</div>
            <Select
              className="col-span-full sm:col-span-2"
              placeholder="Hashtag Name"
              options={options?.chatQuestionTrigger?.data}
              isLoading={isLoading}
              value={
                inputQR.chatQuestionTrigger
                  ? _.find(options.chatQuestionTrigger?.data, {
                      value: inputQR.chatQuestionTrigger,
                    })
                  : ""
              }
              onChange={(e) =>
                setInputQR((prevState) => ({
                  ...prevState,
                  chatQuestionTrigger: e.value,
                  question_trigger: e.question_trigger,
                }))
              }
              isDisabled={_.isEmpty(inputQR.project)}
            />
            {/* USER */}
            <div className="text-sm font-semibold text-gray-600">User</div>
            <Select
              className="col-span-full sm:col-span-2"
              placeholder="User Name"
              options={options?.userOutlet?.data}
              value={
                inputQR.userOutlet
                  ? _.find(options.userOutlet?.data, {
                      value: inputQR.userOutlet,
                    }) ?? options.userOutlet?.data?.[0]
                  : ""
              }
              // value={inputQR.userOutlet}
              onChange={(e) =>
                setInputQR((prevState) => ({
                  ...prevState,
                  userOutlet: e.value,
                }))
              }
              isDisabled={_.isEmpty(inputQR.chatQuestionTrigger)}
            />
            <Banner
              type="error"
              open={!validationQR.general.validate}
              enableClose={false}
            >
              {!validationQR.general.message}
            </Banner>
          </div>
        </div>
        {/* Modal footer */}
        <div className="pb-4 pt-6">
          <div className="flex flex-wrap justify-end space-x-2">
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setShowModal(false);
                setInputQR({});
              }}
              label="Close"
              size="sm"
            />
            <Button
              onClick={(e) => {
                e.stopPropagation();
                if (modalQRDetails.type === "Add") {
                  functionAdd();
                } else if (modalQRDetails.type === "Edit") {
                  functionEdit(inputQR);
                }
              }}
              variant="gradient"
              label={modalQRDetails.title}
              disabled={!inputQR.project || !inputQR.userOutlet}
              size="sm"
            />
          </div>
        </div>
      </ModalBasic>
    </>
  );
}
